import { Converter } from 'showdown';

class AppUtils {
  constructor() {
    this.converter = new Converter({
      tables: true,
      strikethrough: true,
      tasklists: true,
      simplifiedAutoLink: true
    });
  }

  /**
   * Converts markdown to plain text by first converting to HTML and then stripping tags.
   * @param {string} markdown - The markdown string to convert.
   * @returns {string} The plain text.
   */
  markdownToPlainText(markdown) {
    if (!markdown) return '';
    
    // Convert markdown to HTML
    const html = this.converter.makeHtml(markdown);
    
    // Create a temporary DOM element to strip HTML tags
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    
    // Use custom recursive text extraction to preserve list formatting
    let text = this.extractText(tempDiv);
    
    // Clean up excessive newlines (max 2) and trim
    return text.replace(/\n{3,}/g, '\n\n').trim();
  }

  extractText(node, indentLevel = 0) {
    let text = '';
    
    if (node.nodeType === 3) { // Node.TEXT_NODE
      // Replace non-breaking spaces with normal spaces if needed, or keep them.
      // Text content usually has raw whitespace. We might want to collapse it if it's just formatting junk,
      // but pre-formatted code blocks need it.
      // For now, just return as is, but maybe trim empty lines?
      return node.textContent;
    }
    
    if (node.nodeType === 1) { // Node.ELEMENT_NODE
      const tagName = node.tagName.toLowerCase();
      
      // Skip invisible elements
      if (['style', 'script', 'head', 'meta'].includes(tagName)) {
        return '';
      }
      
      if (tagName === 'br') {
        return '\n';
      }
      
      const isBlock = ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'hr'].includes(tagName);
      const isListItem = tagName === 'li';
      
      // Handle List Item prefix
      if (isListItem) {
        // User requested specific bullet format: "- " with indentation for sub-items
        // Example:
        // - Item 1
        //  - Subitem
        const indent = ' '.repeat(indentLevel); 
        // Ensure we start on a new line
        text += `\n${indent}- `;
      }
      
      // Process children
      const childNodes = Array.from(node.childNodes);
      childNodes.forEach(child => {
        let nextIndent = indentLevel;
        
        // If we are in a list item and encountering a nested list, increment indent
        // Note: We check if the CHILD is a list. 
        // The parent (node) is LI.
        if (tagName === 'li' && (child.nodeName === 'UL' || child.nodeName === 'OL')) {
          nextIndent = indentLevel + 1;
        }
        
        text += this.extractText(child, nextIndent);
      });
      
      // Add spacing after block elements
      if (isBlock) {
        text += '\n\n';
      }
      
      return text;
    }
    
    return '';
  }
}

export const appUtils = new AppUtils();
export default AppUtils;

